import styled from 'styled-components';
import TagSelector from '@/trio-ui/TagSelector';

export const CustomTagSelector = styled(TagSelector)`
  margin: 0;
`;

export const InputWrapper = styled.div`
  margin-bottom: 20px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 50%;
  }
`;

export const Form = styled.form``;

export const FormGroup = styled.div`
  &:not(&:last-child) {
    border-bottom: 1px solid;
    border-color: ${(props) => props.theme.colors['neutral-30']};
    padding-bottom: 12px;
  }
  &:not(&:first-child) {
    padding-top: 32px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
`;
